import {
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import { useNotification } from '../../../../helpers/Notification';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import { ENTITY_CONST, USER_CONST } from '../../../auth/login/LoginReducer';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import SelectFieldEntidadesComponent from '../../../entidad/entidades/components/SelectFieldEntidades';
import { allPerfilesAction } from '../../../sistema/perfiles/PerfilesAction';
import CodeQrComponent from '../../usu_entidades/components/code_qr';
import { saveUsuariosAction } from '../UsuariosAction';
import SelectRolesUsuarios from './SelectRolesUsuarios';

const FormUsuarioComponent = ({ isUsuarios = true }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const usuEntidadesStore = Redux.useSelector((state) => state.usuEntidades);
  const usuariosStore = Redux.useSelector((state) => state.usuarios);
  const perfilesStore = Redux.useSelector((state) => state.perfiles);

  const activo = usuariosStore.activo ?? entidadesStore.activo.usuario;

  const initData = {
    correo: '',
    username: '',
    password: '',
    rol: isUsuarios ? USER_CONST : ENTITY_CONST,
    idEstatus: 5,
    idEntEstatus: 6,
    idEntidad: null,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    username: false,
    correo: false,
    password: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);
  const [isSelectEntidad, setIsSelectEntidad] = React.useState(false);

  React.useEffect(() => {
    async function fetchData() {
      if (
        loginStore.isAdmin &&
        perfilesStore.all &&
        perfilesStore.all.length === 0
      ) {
        await allPerfilesAction(dispatch);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (!activo) return;
    const { username, correo, rol } = activo;

    let values = {
      username,
      correo,
      rol,
      idEntEstatus: !isUsuarios
        ? usuEntidadesStore.activo.estatus?.id ?? 6
        : null,
      idEntidad:
        activo.entidades?.length > 0 ? activo.entidades[0]?.entidad?.id : null,
      idEstatus: activo.estatus?.id ?? 5,
    };
    requestAnimationFrame(() => setData(values), 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuariosStore.activo, usuEntidadesStore.activo]);

  React.useEffect(() => {
    setIsSelectEntidad(data.rol === ENTITY_CONST && loginStore.isRoot);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.rol]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];

    if (activo) {
      delete dataError.password;
      delete dataError.perfil;
    }

    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    const { isRoot } = loginStore;

    if (_validDataForm()) {
      setLoadingSave(true);
      const {
        username,
        correo,
        password,
        rol,
        idEntEstatus,
        idEstatus,
        perfil,
      } = data;
      const dataApi = {
        username,
        correo,
        password,
        rol,
        perfil,
        idEntEstatus,
        idEstatus,
        idEntidad: isUsuarios ? null : entidadesStore.activo.id,
      };
      await saveUsuariosAction(
        { dispatch, notify, isRoot },
        isUsuarios,
        usuEntidadesStore.activo,
        activo.id,
        dataApi,
        usuariosStore.params,
      );
      if (password) _handleSetDataField(CONST.password.name, '');
      setLoadingSave(false);
    }
  };

  React.useEffect(() => {
    if (!activo && (data.correo || data.correo !== '')) {
      _handleSetDataField(CONST.username.name, data.correo.split('@')[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.correo]);

  React.useEffect(() => {
    if (!activo && (data.dni || data.dni !== '')) {
      _handleSetDataField(CONST.password.name, data.dni);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.dni]);

  const selectPerfiles = (
    <FormControl fullWidth size="small" error={dataError.perfil}>
      <InputLabel id={`label_${CONST.perfil.name}`}>
        {CONST.perfil.label}
      </InputLabel>
      <Select
        id={CONST.perfil.name}
        value={data.perfil}
        labelId={`label_${CONST.perfil.name}`}
        label={CONST.perfil.label}
        onChange={(e) =>
          _handleSetDataField(CONST.perfil.name, Number(e.target.value))
        }
      >
        {perfilesStore.all.map((el, index) => {
          return (
            <MenuItem key={`perfil-${index}`} value={el.id}>
              {el.nombre}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );

  const selectRoles = (
    <SelectRolesUsuarios
      value={data.rol}
      onChanged={(rol) => {
        _handleSetDataField(CONST.rol.name, rol);
      }}
    />
  );

  const estatus = (
    <EstatusField
      value={data.idEntEstatus ?? data.idEstatus}
      allowIds={[1, 2, 5, 6]}
      onChange={(e) =>
        _handleSetDataField(
          isUsuarios ? CONST.estatus.idName : CONST.entEstatus.idName,
          e.target.value,
        )
      }
    />
  );

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}
        <Grid item xs={12} md={3}>
          {activo?.codeqr && (
            <CodeQrComponent
              size={150}
              maxWidth={150}
              value={activo.codeqr}
              download
              id={`${activo.perfil.pnombre}-${activo.perfil.papellido}`}
            />
          )}
        </Grid>
        <Grid item xs={12} md={9}>
          <Grid container spacing={2}>
            {isUsuarios ? (
              <Grid item xs={12} md={6}>
                {selectRoles}
              </Grid>
            ) : (
              !activo && (
                <Grid item xs={12} md={6}>
                  {selectPerfiles}
                </Grid>
              )
            )}
            {isSelectEntidad && (
              <Grid item xs={12} md={6}>
                <SelectFieldEntidadesComponent
                  isAutoComplete
                  value={data.idEntidad ?? null}
                  onChange={(entidad) =>
                    _handleSetDataField(CONST.entidad.name, entidad)
                  }
                />
              </Grid>
            )}
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                id={CONST.correo.name}
                required
                label={CONST.correo.label}
                value={data.correo}
                onChange={(e) =>
                  _handleSetDataField(CONST.correo.name, e.target.value)
                }
                helperText={dataError.correo ? validMessage.required : null}
                error={dataError.correo}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                id={CONST.username.name}
                required
                label={CONST.username.label}
                value={data.username}
                onChange={(e) =>
                  _handleSetDataField(CONST.username.name, e.target.value)
                }
                helperText={dataError.username ? validMessage.required : null}
                error={dataError.username}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                id={CONST.password.name}
                required={!activo}
                label={CONST.password.label}
                value={data.password ?? ''}
                onChange={(e) =>
                  _handleSetDataField(CONST.password.name, e.target.value)
                }
                helperText={
                  !activo && dataError.password ? validMessage.required : null
                }
                error={activo ? null : dataError.password}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              {loginStore.isRoot ||
              !activo ||
              (loginStore.isAdmin && activo?.estatus.id === 1) ? (
                estatus
              ) : (
                <>
                  <Typography sx={{ fontSize: 15, fontWeight: 'bold' }}>
                    {CONST.estatus.label}:{' '}
                    <Chip
                      label={activo?.estatus.nombre}
                      size="small"
                      color={activo?.estatus.id === 1 ? 'success' : 'error'}
                    />
                  </Typography>
                </>
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text="ACTUALIZAR"
            disabled={loadingSave}
            blue
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormUsuarioComponent;
